/**
 * collection of frontend eror codes - will not contains BE error codes
 *
 * Please document the error codes in this file. It's linked and used as part if the documentation from the README.md
 */
export enum ERROR_CODES {
  // a tournament could not be found or doesn't exists anymore (e.g. wrong tournamentId or competition has been finished)
  TOURNAMENT_NOT_EXISTS = 1,
  // some trouble with the initial rest call to establish the matching connection.
  MATCHING_PROBLEM = 2,
  MATCHING_PROBLEM_WS = 3,
  UNAUTHORIZED = 401,
  UNKNOWN = 3,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
}
